
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.675 11.863a4.188 4.188 0 100-8.377 4.188 4.188 0 000 8.377zm0-1.523a2.665 2.665 0 100-5.33 2.665 2.665 0 000 5.33z","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"6.677","cy":"7.677","r":".937","fill":"currentColor"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M6.742 10.178v3.124M9.177 7.742h3.124M1.055 7.742h3.124M6.742 2.055v3.124"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.823 14.229a3.405 3.405 0 100-6.811 3.405 3.405 0 000 6.81zm0-1.238a2.167 2.167 0 100-4.334 2.167 2.167 0 000 4.334z","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"16.823","cy":"10.822","fill":"currentColor","r":".761"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M16.86 12.854v2.538M18.854 10.801h2.538M12.254 10.801h2.538M16.86 6.254v2.538"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.08 19.96a2.879 2.879 0 100-5.757 2.879 2.879 0 000 5.758zm.001-1.045a1.832 1.832 0 100-3.664 1.832 1.832 0 000 3.664z","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"10.081","cy":"17.08","r":".644","fill":"currentColor"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M10.1 18.799v2.148M11.799 17.01h2.148M6.215 17.01h2.148M10.1 13.215v2.148"}})])
          )
        }
      }
    